import { styled } from 'linaria/react';

export const LoadingDimmerWrapper = styled.div<{ active: boolean }>`
  width: 100%;
  height: 100%;
  position: relative;
  pointer-events: ${(props) => (props.active ? 'none' : 'all')};

  .loader {
    position: absolute;
    z-index: 1000;
    margin: auto;
    inset: 0;
  }
`;

export const BlurArea = styled.div<{ active: boolean }>`
  filter: ${(props) => (props.active ? 'blur(3px)' : 'none')};
`;
